import { createElementVNode as _createElementVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "steps__step-form" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h3", { class: "h4 h4--b" }, " Select client, key contact & collaborators ", -1 /* HOISTED */)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", { class: "mb-24" }, " All fields are required unless indicated as optional. ", -1 /* HOISTED */)
const _hoisted_4 = ["onSubmit"]
const _hoisted_5 = {
  class: "button button--fill",
  type: "submit"
}

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _createElementVNode("form", {
      class: "form form--fixed-fields",
      onSubmit: _withModifiers($setup.updateForm, ["prevent"])
    }, [
      _createVNode($setup["InputComponent"], {
        value: $setup.form_fields.client,
        type: "button-dropdown",
        "input-id": "client",
        name: "client",
        label: "Client company",
        "sub-label": "Select a client from the database or create a new one",
        placeholder: "Search",
        options: $setup.filtered_client_companies,
        "filter-key": "client",
        "filter-search": $setup.form_fields.client.search_query,
        required: true,
        errors: $setup.form_errors.client || null,
        "onUpdate:value": _cache[0] || (_cache[0] = ( value ) => $setup.handleButtonDropdownUpdate( value, 'client' ))
      }, null, 8 /* PROPS */, ["value", "options", "filter-search", "errors"]),
      _createVNode($setup["NewCompanyFormComponent"], {
        "field-handle": "client",
        "form-title": "Client company",
        "show-short-code-field": true,
        "onRefresh:companies": _cache[1] || (_cache[1] = ( value, handle ) => $setup.updateCompanies( value, handle ))
      }),
      _createVNode($setup["InputComponent"], {
        value: $setup.form_fields.key_client_contact,
        type: "checkboxes-dropdown",
        "input-id": "key-client-contact",
        name: "key-client-contact",
        label: "Key client contact",
        "sub-label": "Select multiple contacts from the list or create a new one",
        placeholder: "Search",
        options: $setup.filtered_key_client_contacts,
        "selection-label": $setup.selected_key_client_contacts_label,
        "filter-key": "key_client_contact",
        "filter-search": $setup.form_fields.key_client_contact.search_query,
        "active-values": $setup.form_fields.key_client_contact.values,
        required: true,
        errors: $setup.form_errors.key_client_contact || null,
        "onUpdate:value": _cache[2] || (_cache[2] = ( value ) => $setup.handleCheckboxDropdownUpdate( value, 'key_client_contact' ))
      }, null, 8 /* PROPS */, ["value", "options", "selection-label", "filter-search", "active-values", "errors"]),
      _createVNode($setup["NewClientUserFormComponent"], {
        "field-handle": "key_client_contact",
        "form-title": "Key client contact",
        "onRefresh:clientUsers": _cache[3] || (_cache[3] = ( value, handle ) => $setup.updateClientUsers( value, handle ))
      }),
      _createVNode($setup["InputComponent"], {
        value: $setup.form_fields.client_billing_contact,
        type: "checkboxes-dropdown",
        "input-id": "client-billing-contact",
        name: "client-billing-contact",
        label: "Client billing contact",
        "sub-label": "Select multiple contacts from the list or create a new one",
        placeholder: "Search",
        options: $setup.filtered_client_billing_contacts,
        "selection-label": $setup.selected_client_billing_contacts_label,
        "filter-key": "client_billing_contact",
        "filter-search": $setup.form_fields.client_billing_contact.search_query,
        "active-values": $setup.form_fields.client_billing_contact.values,
        required: true,
        errors: $setup.form_errors.client_billing_contact || null,
        "onUpdate:value": _cache[4] || (_cache[4] = ( value ) => $setup.handleCheckboxDropdownUpdate( value, 'client_billing_contact' ))
      }, null, 8 /* PROPS */, ["value", "options", "selection-label", "filter-search", "active-values", "errors"]),
      _createVNode($setup["NewClientUserFormComponent"], {
        "field-handle": "client_billing_contact",
        "form-title": "Client billing contact",
        "onRefresh:clientUsers": _cache[5] || (_cache[5] = ( value, handle ) => $setup.updateClientUsers( value, handle ))
      }),
      _createVNode($setup["InputComponent"], {
        value: $setup.form_fields.email_client_when_live,
        type: "checkbox",
        "input-id": "email-client-when-live",
        name: "email-client-when-live",
        label: "Send key contact email when project is live",
        errors: $setup.form_errors.email_client_when_live || null,
        "onUpdate:value": _cache[6] || (_cache[6] = new_value => $setup.form_fields.email_client_when_live = new_value)
      }, null, 8 /* PROPS */, ["value", "errors"]),
      _createVNode($setup["InputComponent"], {
        value: $setup.form_fields.clients,
        type: "checkboxes-dropdown",
        "input-id": "clients",
        name: "clients",
        label: "Additional client contacts",
        "sub-label": "Add clients here to grant permission to view this project. Optional",
        placeholder: "Search",
        options: $setup.filtered_clients,
        "selection-label": $setup.selected_clients_label,
        "filter-key": "clients",
        "filter-search": $setup.form_fields.clients.search_query,
        "active-values": $setup.form_fields.clients.values,
        required: true,
        errors: $setup.form_errors.clients || null,
        "onUpdate:value": _cache[7] || (_cache[7] = ( value ) => $setup.handleCheckboxDropdownUpdate( value, 'clients' ))
      }, null, 8 /* PROPS */, ["value", "options", "selection-label", "filter-search", "active-values", "errors"]),
      _createVNode($setup["NewClientUserFormComponent"], {
        "field-handle": "clients",
        "form-title": "Client contact",
        "onRefresh:clientUsers": _cache[8] || (_cache[8] = ( value, handle ) => $setup.updateClientUsers( value, handle ))
      }),
      _createElementVNode("button", _hoisted_5, " Save " + _toDisplayString($props.stepTitle), 1 /* TEXT */)
    ], 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_4)
  ]))
}